import { render, staticRenderFns } from "./SystemSettingsSocialMediaModal.vue?vue&type=template&id=42ae8b0a"
import script from "./SystemSettingsSocialMediaModal.vue?vue&type=script&lang=js"
export * from "./SystemSettingsSocialMediaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports